import { analyticsEventTracker, EVENT_CATEGORIES } from 'hooks/UseAnalyticsTracker';

export const PopupVolcanosMarker = ({
  volcanoName, elevation, lat, lng, levelIcon, 
  image, id, lastEruption, volcanoTipe, activityDesc
}) => {

  return (
    <div className = "container-popup-volcano-marker">

      <div className = "main-popup">
        <div className = "image-title-popup">
          <div
            className = "img-container"
            style = {{ backgroundImage: `url('${ image }')` }}
          >
            <div className="level-activity-container">
              <img src = { levelIcon } alt = "Estado de alerta" />
            </div>
          </div>
          <div className = "title-container">
            <p>
              <span className = "title-event-pp">
                { volcanoName }
              </span>
            </p>
            <p>
              <span>Elevación:</span> { elevation }
            </p>
            <p>
              <span>Estado de alerta:</span> { activityDesc }
            </p>
          </div>
        </div>
        <div className = "info-popup">
          <div className = "info-container">
            <hr />
            <p>
              <span>Localización:</span> { lat }&#176;, { lng }&#176;
            </p>
            {
              volcanoTipe !== null && (
                <p>
                  <span>Tipo de volcán:</span> { volcanoTipe }
                </p>
              )
            }
            {
              lastEruption !== null && (
                <p>
                  <span>Última erupción conocida:</span> { lastEruption }
                </p>
              )
            }
          </div>
        </div>
        <div className = "btn-container-pp">
            <a
              target = "_blank"
              rel = "noopener noreferrer"
              href = { `/detallevolcan/${ id }/` }
              onClick = {
                () => analyticsEventTracker({
                  category: EVENT_CATEGORIES.vulcans,
                  action: `Más información from VViewer PopUp`,
               }) 
              }
            >
              <button>Más información</button>
            </a>
        </div>
      </div>
    </div>
  )
}
